'use client';
import { useState } from 'react';
import style from './footer-icon.module.scss';
import { usePathname, useRouter } from 'next/navigation';
import { useAuthContext } from '../Auth/context/AuthContext';
import {
  useMobileMenuSelector,
  useUserSelector,
  useIsLoggingSelector,
} from '../../store/selectors';
import { useAppSelector } from '../../hooks/useAppSelector/UseAppSelector';
import {
  setMobileProfileMenuStatus,
  setIsSearchStatus,
} from '../../store/slices/mobileMenu/MobileMenuSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch/UseAppDispatch';
import FooterIcon, { FooterSearch } from './FooterIcon';
import MobileMenu from '../MobileMenu/MobileMenu';
import classNames from 'classnames';
import { useMobileMenuisSearchSelector } from '@/src/v2/store/selectors';
const MobileFooter = ({ user }) => {
  const reduxUser = useAppSelector(useUserSelector);
  const isLogging = useAppSelector(useIsLoggingSelector);
  const profileState = useAppSelector(useMobileMenuSelector);
  //const [isSearchds, setIsSearch] = useState(false);
  const [error, setError] = useState(false);
  const { setMode } = useAuthContext();
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  const isSearch = useAppSelector(useMobileMenuisSearchSelector);

  const handleSearch = () => {
    dispatch(setMobileProfileMenuStatus(false));
    //setIsSearch(!isSearch);
    console.log(isSearch);
    dispatch(setIsSearchStatus(!isSearch));
  };
  const setIsSearch = (isOpen: boolean) => {
    dispatch(setIsSearchStatus(isOpen));
  };
  const handleMenuClose = () => {
    dispatch(setMobileProfileMenuStatus(isSearch));
  };

  // Conditional rendering: don't render footer on event page
  if (pathname.includes('/event')) {
    return null;
  }
  return (
    <>
      {profileState && <MobileMenu handleMenuClose={handleMenuClose} />}
      <div className={style['footer-menu__container']}>
        <div>
          <FooterIcon
            onClick={() => {
              setIsSearch(false);
              dispatch(setMobileProfileMenuStatus(false));
              router.push('/');
            }}
            imgSrc={
              pathname === '/' && !(profileState || isSearch)
                ? '/icons/home.svg'
                : '/icons/homeDeactive.svg'
            }
            alt={'home'}
          />
        </div>
        <div>
          <FooterIcon
            onClick={handleSearch}
            imgSrc={
              isSearch ? '/icons/search.svg' : '/icons/searchDeactive.svg'
            }
            alt={'search'}
          />
        </div>
        <div>
          <FooterIcon
            onClick={() => {}}
            imgSrc={'/icons/beta.logo.svg'}
            alt={'create'}
          />
        </div>
        <div>
          <FooterIcon
            onClick={() => {
              setIsSearch(false);
              dispatch(setMobileProfileMenuStatus(false));
              if (reduxUser) {
                router.push(`/${user?.username}/dashboard/following`);
              } else {
                setMode('sign in');
              }
            }}
            imgSrc={
              pathname.includes('/dashboard/following') &&
              !profileState &&
              !isSearch
                ? '/icons/klic-channel.svg'
                : '/icons/followingDeactive.svg'
            }
            alt={'following'}
            className={classNames({
              [style['footer-menu__container--active']]:
                pathname.includes('/dashboard/following') &&
                !profileState &&
                !isSearch,
            })}
          />
        </div>
        <div>
          <FooterIcon
            onClick={() => {
              setIsSearch(false);
              if (reduxUser) {
                dispatch(setMobileProfileMenuStatus(!profileState));
              } else {
                setMode('sign in');
              }
            }}
            imgSrc={`${
              reduxUser && reduxUser?.avatar
                ? reduxUser?.avatar
                : '/icons/profile.svg'
            }`}
            setError={setError}
            error={error}
            alt={'profile'}
            className={classNames({
              [style['footer-menu__container--active']]: profileState,
              [style['footer-menu__container--userprofile']]:
                reduxUser?.avatar !== '',
              [style['footer-menu__container--no-avatar']]: !reduxUser?.avatar, // Add this line
            })}
          />
        </div>
      </div>
      <FooterSearch isSearch={isSearch} setIsSearch={setIsSearch} />
    </>
  );
};

export default MobileFooter;
